<template>
  <div>
    <div :id="id" :style="{height:height,width:width}"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
// import '../../../node_modules/echarts/map/js/china.js'
import resize from './mixins/resize'
export default {
  mixins: [resize],
  props: {
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    name: {
      type: String,
      default: '空'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    }
  },
  data () {
    return {
      chart: null
    }
  },
  watch: {
    option: {
      handler (newValue, oldValue) {
        this.initChart()
      },
      deep: true
    }
  },
  mounted () {
    if (this.option) this.initChart()
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      this.chart = echarts.init(document.getElementById(this.id), {}, { renderer: 'svg' })
      this.chart.setOption({
        background: '#ffffff',
        title: {
          text: this.name,
          x: 'center',
          top: 50,
          textStyle: {
            fontSize: 12,
            color: 'rgba(255, 255, 255, 0.4)',
            lineHeight: 30
          }
        },
        visualMap: {
          min: this.option.min,
          max: this.option.max,
          right: 5,
          bottom: 20,
          calculable: true,
          show: true,
          itemWidth: 10,
          itemHeight: 100,
          textStyle: {
            fontSize: 10,
            color: '#F1F1F3'
          },
          color: ['#0075ff', '#00eab8']
        },
        geo: {
          map: 'china',
          roam: true,
          zoom: 1,
          scaleLimit: { min: 0, max: 3 },
          label: {
            normal: {
              show: true,
              fontSize: 10,
              color: '#fff'
            }
          },
          itemStyle: {
            normal: {
              borderColor: '#1c1839',
              borderWidth: 1
            }
          },
          regions: [
            {
              name: '南海诸岛',
              value: 0,
              itemStyle: {
                normal: {
                  opacity: 0,
                  label: {
                    show: false
                  }
                }
              },
              label: {
                normal: {
                  show: false
                }
              }
            }, {
              name: '香港',
              value: 0,
              itemStyle: {
                normal: {
                  opacity: 0,
                  label: {
                    show: false
                  }
                }
              },
              label: {
                normal: {
                  show: false
                }
              }
            }, {
              name: '澳门',
              value: 0,
              itemStyle: {
                normal: {
                  opacity: 0,
                  label: {
                    show: false
                  }
                }
              },
              label: {
                normal: {
                  show: false
                }
              }
            }
          ]
        },
        series: [
          {
            type: 'map',
            roam: true,
            geoIndex: 0,
            data: this.option.stockDetail
          }
        ]
      })
    }
  },
  created () {}
}
</script>
